// extracted by mini-css-extract-plugin
export default {"partially-in-stock":"orders-page_partially-in-stock__1gke6","in-stock":"orders-page_in-stock__X+Hy2","overused":"orders-page_overused__eXuFC","table":"orders-page_table__ilRlQ","tableMiddle":"orders-page_tableMiddle__xgWLK"};
    if(module.hot) {
      // 1790680669423
      var cssReload = require("/home/garphild.pro/web/drones.garphild.pro/private/nodeapp/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  